import React from 'react';

const Image = (props) => {
  const { alt, src, userPage, selectImage } = props;

  return (
    <div className="col-sm-6 mb-3">
      <img
        alt={alt}
        src={src}
        style={{
          height: 110,
          width: 110,
          margin: 0.5
        }}
        onClick={selectImage}
      />
      <p style={{ fontSize: '0.7rem' }}>
        <u>
          <a href={userPage} target="__blank" rel="noopener noreferrer">
            Visit author
          </a>
        </u>
      </p>
    </div>
  );
};

export default Image;
